
import moment from 'moment'

export default {
  data() {
      return {
          category: 'all',
          articles: [],
          selectedCategoryArticles: [],
          query: '',
          dropdown: false,
          pages: 1,
          page: 1
      };
  },
  props: {
    blok: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    filteredArticles() {
      if (!this.selectedCategoryArticles || !this.selectedCategoryArticles.length) {
        return [];
      }
      let articles = this.selectedCategoryArticles;
      if (this.pages > 1) {
        articles = articles.filter((_, index) => index < (this.page * 9) && index >= ((this.page - 1) * 9));
      }
      if (this.category === 'all' && (this.pages === 0 || this.pages === 1) && this.query === '') {
        articles = articles.filter((_, index) => index >= 0);
      }
      return articles;
    }
  },
  async mounted() {
    // const response = await this.$storyblok.getStories('news-and-community')
    // const newsStory = response.find(story => story.slug === 'news-and-community')
    // const articles = newsStory.content.body.find(item => item.component === 'article-grid').card

    this.articles = this.blok.articles;
    this.selectedCategoryArticles = this.blok.articles;
    this.pages = Math.ceil(this.selectedCategoryArticles.length / 9);

    if (process.browser && window.location.hash.length) {
      if (window.location.hash == '#our-food') {
          this.setCategory('food');
      }
      if (window.location.hash == '#our-people') {
          this.setCategory('people');
      }
      if (window.location.hash == '#our-community') {
          this.setCategory('community');
      }
      if (window.location.hash == '#our-growth') {
          this.setCategory('growth');
      }
      history.replaceState(null, null, ' ');
    }
  },
  methods: {
      setCategory(category) {
        this.query = '';
        this.category = category;
        let selectedCategoryArticles = [];
        if (category !== 'all') {
            selectedCategoryArticles = this.articles.filter(article => article.category[0] == category);
        }
        else {
            selectedCategoryArticles = this.articles;
        }
        this.selectedCategoryArticles = selectedCategoryArticles;
        this.pages = Math.ceil(selectedCategoryArticles.length / 9);
        this.page = 1;
      },
      search() {
        this.page = 1;
        this.category = 'all';
        const lowerCaseQuery = this.query.toLowerCase();
        let filtered = this.articles.filter(article => {
            const titleContainsQuery = article.heading.toLowerCase().includes(lowerCaseQuery);
            const bodyContainsQuery = article.subheading.toLowerCase().includes(lowerCaseQuery);
            return titleContainsQuery || bodyContainsQuery;
        });
        if (!this.query.length) {
            filtered = this.articles;
        }
        this.pages = Math.ceil(filtered.length / 9);
        this.selectedCategoryArticles = [...new Set(filtered)];
      },
  },
}
